// extracted by mini-css-extract-plugin
module.exports = {"container":"Team_container__hkrvH","left":"Team_left__2HDGw","right":"Team_right__3SgeU","error":"Team_error__1oDfH"};